import { createAsyncThunk } from '@reduxjs/toolkit';

import { ForbiddenError } from '../../api/errors/ForbiddenError';
import {
  fetchPromoPoints,
  type FetchPromoPointsParams,
  type FetchPromotionParams,
  fetchPromotions,
  type FetchPromotionTranslationParams,
  fetchPromoTranslations,
  getJwtTokenForPromo,
} from '../../api/fetchers/promotions/fetcher';

export const fetchPromotionAction = createAsyncThunk('promotion/fetchPromotions', (params: FetchPromotionParams) =>
  fetchPromotions(params).catch((error: Error) => {
    if (!(error instanceof ForbiddenError)) {
      return getJwtTokenForPromo(params).then((jwtToken) => {
        params.jwtToken = jwtToken;
        params.force = true;
        return fetchPromotions(params);
      });
    }
    throw error;
  })
);

export const fetchPromotionTranslationAction = createAsyncThunk(
  'promotion/fetchPromotionTranslation',
  (params: FetchPromotionTranslationParams) => fetchPromoTranslations(params)
);

export const fetchPromoPointsAction = createAsyncThunk('promotion/fetchPromoPoints', (params: FetchPromoPointsParams) =>
  fetchPromoPoints(params)
);
